import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { NonExchangeDay } from '../../../../app/models/NonExchangeDay';
import { Currency } from '../../../../app/models/Currency';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';

interface Props {
    nonExchangeDayDataForm: NonExchangeDay;
    setNonExchangeDayDataForm: (nonExchangeDayDataForm: NonExchangeDay) => void;
    errorFields?: any;
    currencies: Currency[];
}

const NonExchangeDayForm = ({ nonExchangeDayDataForm, setNonExchangeDayDataForm, errorFields, currencies }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setNonExchangeDayDataForm({ ...nonExchangeDayDataForm, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Nombre</label>
                    <input
                        name="name"
                        id="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={nonExchangeDayDataForm.name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Ingrese el nombre del día de no cambio"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('name')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Fecha Referencia</label>
                    <input
                        name="date"
                        id="date"
                        type="date"
                        className={`form-control ${fieldHasError('date')}`}
                        value={nonExchangeDayDataForm.date}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('date')}
                        placeholder="Seleccione la fecha de referencia"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('date')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Período</label>
                    <select
                        name="period"
                        id="period"
                        className={`form-control form-control-custom ${fieldHasError('period')}`}
                        value={nonExchangeDayDataForm.period}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('period')}
                    >
                        <option value="">Seleccione un período</option>
                        <option value="NO_REPEAT">No repetir</option>
                        <option value="WEEKLY">Semanal</option>
                        <option value="MONTHLY">Mensual</option>
                        <option value="YEARLY">Anual</option>
                    </select>
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('period')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Monedas a aplicar para cambios a CLP (Banco Central de Chile)</label>
                    <SelectTwo
                        name="currencies"
                        id="currencies"
                        inputValue={nonExchangeDayDataForm.currencies}
                        options={SelectTwoMapperOptions(currencies)}
                        hasError={fieldHasError('currencies') !== ''}
                        onChange={(value: any) =>
                            setNonExchangeDayDataForm({
                                ...nonExchangeDayDataForm,
                                currencies: value
                            })
                        }
                        isMulti={true}
                        placeholder="Seleccione monedas"
                        onFocus={() => onFocusRemove('currencies')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('currencies')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default NonExchangeDayForm; 